import { render, staticRenderFns } from "./AdditionalServicePage.vue?vue&type=template&id=73e68f07&scoped=true"
import script from "./AdditionalServicePage.vue?vue&type=script&lang=js"
export * from "./AdditionalServicePage.vue?vue&type=script&lang=js"
import style0 from "./AdditionalServicePage.vue?vue&type=style&index=0&id=73e68f07&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e68f07",
  null
  
)

export default component.exports